<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
        <h6 class="proxima-nova-bold mb-3">Invoices with no order</h6>
        <table
            class="client1-table table-format set_column_width table table-striped table-bordered dt-responsive nowrap"
            style="width:100% !important" cellspacing="0">
            <thead>
            <tr>
                <th scope="col" style="width: 200px">Client</th>
                <th scope="col" style="width: 100px">#</th>
                <th scope="col">Orders</th>
                <th scope="col" style="width: 200px"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(invoice, idx) in xInvoices" :key="idx">
                <td>
                    <span v-if="invoice.client">
                        {{ invoice.client.name }} ({{ invoice.client.organization.name }})
                    </span>
                </td>
                <td>
                    <a :href="`/billing/print/${invoice.external_id}`">{{ invoice.number }}</a>
                </td>
                <td v-if="invoice.isEditable">
                    <select
                        class="custom-select"
                        v-model="invoice.order_id"
                    >
                        <option
                            v-for="order in invoice.client.orders"
                            :key="order.id"
                            :value="order.id"
                        >
                            {{ `${order.number} ${order.domain.name_utf8} (${order.contract_status})` }}
                        </option>
                    </select>
                </td>
                <td v-else>
                    <a v-if="invoice.order" :href="`/orders/${invoice.order.number}`" target="_blank">{{ invoice.order.number }}</a>
                    <span v-else>order is missing</span>
                </td>
                <td>
                    <button
                        class="btn btn-primary"
                        v-if="!invoice.isEditable"
                        @click="editInvoice(invoice)">
                        Edit
                    </button>
                    <button
                        class="btn btn-primary"
                        v-if="invoice.isEditable"
                        :disabled="!invoice.order_id"
                        @click="updateInvoice(invoice)">
                        Save
                    </button>
                    <button
                        class="btn" v-if="invoice.isEditable"
                        @click="cancelEdit(invoice)">
                        Cancel
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>


export default {
    name: 'select-invoice-order',
    props: ['invoices'],
    data: function () {
        return {
            xInvoices: [],
        };
    },
    mounted() {
        this.invoices.forEach((invoice) => {
            this.xInvoices.push({
                ...invoice,
            });
        })
    },
    updated() {
    },
    methods: {
        editInvoice(invoice) {
            invoice.isEditable = true;
        },
        cancelEdit(invoice) {
            invoice.isEditable = false;
            invoice.order_id = null;
        },
        updateInvoice(invoice) {
            invoice.order = invoice.client.orders.find(obj => {
                return obj.id === parseInt(invoice.order_id)
            })
            axios.post('/invoices/drafts/select', {
                invoice_draft_id: invoice.id,
                order_id: invoice.order.id
            }).then(() => {
                invoice.isEditable = false;
            });
        },
    }
}
</script>
<style scoped>
.blue-button {
    color: #fff;
    display: block;
    border-radius: 5px;
    padding: 5px 25px;
    text-decoration: none;
    border: transparent;
    background-color: #50a1ff;
}

.blue-button:disabled {
    background-color: #79a8de !important;
}

.blue-button:hover:enabled {
    background-color: #14d2b8;
}

.custom-select {
    font-family: Arial, serif;
    width: auto !important;
}


</style>
